import type { ReactElement } from 'react'
import { useEffect } from 'react'

import Link from '../../templateComponents/Link'

type Props = {
  shopHref: string
} & TranslateProps

export default function CartEmptyNote({ t, shopHref }: Readonly<Props>): ReactElement {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className="cart">
      <section className="section">
        <div className="wrapper">
          <div className="content">
            <h1 className="cart-headline">{t('views.storefrontView.basketPageSection.emptyState.title')}</h1>
            <div className="cart-empty-note">
              <h3>{t('views.storefrontView.basketPageSection.emptyState.explanation')}</h3>
              <p>
                <Link to={shopHref}>{t('views.storefrontView.basketPageSection.emptyState.continueShoppingLink')}</Link>
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
